import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { MdEmail, MdArrowBack } from 'react-icons/md';

const EmailConfirmation = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const email = location.state?.email;

    if (!email) {
        navigate('/login', { replace: true });
        return null;
    }

    return (
        <div className="flex min-h-screen bg-gray-50">
            {/* Left Section with Illustration */}
            <div className="hidden lg:flex lg:w-1/2 bg-blue-600 relative">
                <div className="absolute inset-0 bg-gradient-to-b from-blue-500/50 to-blue-700/50"></div>
                <div className="relative z-10 p-12 flex flex-col justify-center items-center text-white">
                    <div className="w-64 h-64 bg-white/10 rounded-full flex items-center justify-center mb-8">
                        <MdEmail className="w-32 h-32 text-white" />
                    </div>
                    <h2 className="text-3xl font-bold mb-4 text-center">
                        {t('emailConfirmation.title')}
                    </h2>
                    <p className="text-xl opacity-90 text-center max-w-md">
                        {t('emailConfirmation.postMessage')}
                    </p>
                </div>
            </div>

            {/* Right Section with Content */}
            <div className="w-full lg:w-1/2 flex items-center justify-center p-4 sm:p-8">
                <div className="max-w-md w-full space-y-8">
                    {/* Mobile Version of Title (shown only on mobile) */}
                    <div className="lg:hidden text-center mb-8">
                        <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <MdEmail className="w-12 h-12 text-blue-600" />
                        </div>
                        <h2 className="text-2xl font-bold text-gray-900">
                            {t('emailConfirmation.title')}
                        </h2>
                    </div>

                    {/* Email Confirmation Details */}
                    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 sm:p-8">
                        <div className="text-center space-y-4">
                            <p className="text-gray-600 text-lg">
                                {t('emailConfirmation.preMessage')}
                            </p>
                            <p className="text-xl font-semibold text-gray-900 break-all bg-gray-50 p-3 rounded-lg">
                                {email}
                            </p>
                            <p className="text-gray-600 text-lg">
                                {t('emailConfirmation.postMessage')}
                            </p>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="space-y-6">
                        <button
                            onClick={() => navigate('/login', { replace: true })}
                            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            aria-label={t('emailConfirmation.backToLogin')}
                        >
                            <MdArrowBack className="text-xl" aria-hidden="true" />
                            {t('emailConfirmation.backToLogin')}
                        </button>

                        {/* Help Section */}
                        <div className="text-center space-y-4 pt-2">
                            <p className="text-base text-gray-600">
                                {t('emailConfirmation.noEmail')}
                            </p>
                            <a
                                href="mailto:support@spainhacks.com"
                                className="inline-flex items-center justify-center px-4 py-2 text-blue-600 hover:text-blue-700 font-medium transition-colors focus:outline-none focus:underline"
                                aria-label={t('emailConfirmation.contactSupport')}
                            >
                                {t('emailConfirmation.contactSupport')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailConfirmation; 